import Vue from 'vue';
import Router from 'vue-router';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import service from './services';
import storage from './services/storage';
import jwt from 'jsonwebtoken';
import { KEY_LOCAL_STORAGE } from './const';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/Index.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/ajuda',
      name: 'Ajuda',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/Ajuda.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
    {
      path: '/QuemSomos',
      name: 'Quem Somos',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/QuemSomos.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/p/:produto',
      name: 'produto',
      beforeEnter: async function(to, from, next) {
        removeClass();
        // await getDadosProdutos(to, from, next);
        next();
      },
      components: {
        default: () => import('./pages/Detalhes.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
    {
      path: '/:loja/p/:produto',
      name: 'produtoLoja',
      beforeEnter: async function(to, from, next) {
        removeClass();
        await getDadosProdutos(to, from, next);
        //next();
      },
      components: {
        default: () => import('./pages/Detalhes.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },

    {
      path: '/:loja',
      name: 'indexLoja',
      beforeEnter: async function(to, from, next) {
        removeClass();
        next();
      },
      components: {
        default: () => import('./pages/Index.vue'),
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          colorOnScroll: 80,
        },
      },
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

function isAuth(to, next, toAdmin) {
  const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
  if (token) {
    const decoded = jwt.decode(token);
    service
      .validaToken(token, 'Login', 'ValidateToken')
      .then(res => {
        if (res.data.result == false) {
          removeToken(next, to.name);
        } else {
          next();
        }
      })
      .catch(e => {
        console.error(e);
        removeToken(next, to.name);
      });
  } else {
    removeToken(next, to.name);
  }
}

async function getDadosProdutos(to, from, next) {
  // to.params.produto = URL do produto (final_link) decodificada pelo vue-router
  const url = to.params.produto;
  service
    .getAll('superOfertas', null, 'offer?url=' + encodeURIComponent(url))
    .then(res => {
      if (res.data && res.data.id) {
        storage.escreveStorage('pr', JSON.stringify(res.data));
      }
      next();
    })
    .catch(() => next());
}

function removeToken(next, name) {
  storage.removeItem(KEY_LOCAL_STORAGE.USER_TOKEN);
  storage.removeItem(KEY_LOCAL_STORAGE.SALDO);
  storage.removeItem(KEY_LOCAL_STORAGE.QUANT_ITENS);
  storage.removeItem(KEY_LOCAL_STORAGE.VALORCREDITO);
  //storage.clear();
  if (name) next(`/Login?redirect=${name}`);
  else next(`/Login`);
}

function removeClass() {
  let htmlClasses = document.querySelector('html').classList;
  htmlClasses.remove('nav-open');
}
